module.exports = __webpack_public_path__ + "img/Create Feedback.d69fa104.png";